import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BannerWithSearch } from '@/components';
import { useConfigContext } from '@/hoc';
import useSessionStorage from '@/hooks/use-session-storage';
import { useCallback } from 'react';
import { ManageMyJobs } from './manage-my-jobs';
import AuthSection from '@/components/auth';
export var Template1 = function (_a) {
    var isPreview = _a.isPreview;
    return (_jsxs("div", { className: 'flex gap-2 flex-col', children: [_jsx(AuthSection, {}), _jsx(ManageMyJobs, { isPreview: isPreview })] }));
};
export var Template2 = function (_a) {
    var isPreview = _a.isPreview;
    var _b = useConfigContext().config, bannerUrl = _b.bannerUrl, jobListingPageUrl = _b.jobListingPageUrl;
    var _c = useSessionStorage({
        key: 'jobFilters',
        initialValue: {
            appliedFilters: [],
        },
        config: { raw: false },
    }), filters = _c[0], setJobFilters = _c[1];
    var setFilters = useCallback(function (value) {
        setJobFilters(value);
        window.location.href = jobListingPageUrl !== null && jobListingPageUrl !== void 0 ? jobListingPageUrl : '/';
    }, [setJobFilters, jobListingPageUrl]);
    return (_jsxs("div", { className: 'flex gap-4 flex-col', children: [_jsx(BannerWithSearch, { bannerUrl: bannerUrl, filters: filters, setFilters: setFilters }), _jsx(ManageMyJobs, { isPreview: isPreview })] }));
};
export var ManageMyJobsTemplateMap = function (_a) {
    var isPreview = _a.isPreview;
    var templateId = useConfigContext().config.templateId;
    switch (templateId) {
        case 1:
            return _jsx(Template1, { isPreview: isPreview });
        case 2:
            return _jsx(Template2, { isPreview: isPreview });
        default:
            return _jsx(Template1, { isPreview: isPreview });
    }
};
